import { Component } from "react";

class Usecases extends Component {

  render() {
    return <div className="wrapper-tools">
      <h3>Use cases</h3>
      <p>
        Heber, A.; Lottje, C.; Below, T.; Voss, M.; Rued, S.; Saavedra, C.; Bwalya, A.; Chikomba, P.; Bonilla Findji, O. (2024) <br/>Applying the CRISP tool in Bolivia and Zambia: Identifying climate risks and adaptation options in agricultural and food system projects. 6 p. <a href="https://hdl.handle.net/10568/149058" target="_blank">https://hdl.handle.net/10568/149058</a>
      </p>
      <p>
        Application de l'outil CRISP en Bolivie et en Zambie : Identification des risques climatiques et des options d'adaptation dans des projets de systèmes agricoles et alimentaires. <a href="https://hdl.handle.net/10568/174100" target="_blank">https://hdl.handle.net/10568/174100</a>
      </p>
      <p>
        Aplicación de la herramienta CRISP en Bolivia y Zambia: Identificación de riesgos climáticos y opciones de adaptación en proyectos de sistemas agrícolas y alimentarios. <a href="https://hdl.handle.net/10568/174123" target="_blank">https://hdl.handle.net/10568/174123</a>
      </p>
    </div>
  }
}
export default Usecases;
